var _defs, _g, _rect, _path, _path2, _g2, _g3, _rect2, _path3, _path4, _circle, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 384 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 193.38,
    x2: 193.84,
    y1: 71.815,
    y2: 290.49,
    gradientTransform: "translate(0 15.672)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80c6ed",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80c6ed",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 45.448,
    x2: 45.448,
    y1: 92.54,
    y2: 7.0165,
    gradientTransform: "scale(1.0059 .99417)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.58824,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: -0.047721,
    y: -0.048282,
    width: 1.0954,
    height: 1.0966,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 47.5,
    cy: 59.494,
    r: 37.054,
    gradientTransform: "matrix(1.1227 1.0047e-8 0 1.0388 -5.8315 -6.8641)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347aa1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 84,
    height: 84,
    rx: 6,
    ry: 6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: -0.19506,
    y: -0.19506,
    width: 1.3901,
    height: 1.3901,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 15.594,
    x2: 111.61,
    y1: 61.448,
    y2: 61.448,
    gradientTransform: "matrix(.70315 0 0 .69956 3.1971 4.0472)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc730",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc730",
    offset: 0.2202
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc730",
    offset: 0.56107
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc730",
    stopOpacity: 0,
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92741 0 0 .92992 -45.417 -46.061)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,416)",
    display: "none",
    strokeWidth: 0.78542
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 86,
    height: 85,
    rx: 6,
    ry: 6,
    fill: "url(#f)",
    filter: "url(#c)",
    opacity: 0.9,
    strokeWidth: 0.76384
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.888,0,0,4.888,23.821,18.322)",
    strokeWidth: 0.80761
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.446,
    y: 11.5,
    width: 74.107,
    height: 74.25,
    rx: 5.5667,
    ry: 5.8378,
    fill: "url(#e)",
    strokeWidth: 0.80761
  })), /*#__PURE__*/React.createElement("path", {
    d: "m19 13c-3.2894 0-6 2.7106-6 6v58c0 3.2894 2.7106 6 6 6h58c3.2894 0 6-2.7106 6-6v-58c0-3.2894-2.7106-6-6-6zm0 4h58c1.1426 0 2 0.85741 2 2v58c0 1.1426-0.85741 2-2 2h-58c-1.1426 0-2-0.85741-2-2v-58c0-1.1426 0.85741-2 2-2z",
    color: "#000000000",
    opacity: 0.15,
    strokeWidth: 0.78542,
    style: {
      textDecorationLine: "none",
      textIndent: 0,
      textTransform: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 14c-1.662 0-3 1.338-3 3v62c0 1.662 1.338 3 3 3h62c1.662 0 3-1.338 3-3v-62c0-1.662-1.338-3-3-3zm0 1.9375h62c0.61816 0 1.0625 0.44434 1.0625 1.0625v62c0 0.61816-0.44434 1.0625-1.0625 1.0625h-62c-0.61816 0-1.0625-0.44434-1.0625-1.0625v-62c0-0.61816 0.44434-1.0625 1.0625-1.0625z",
    color: "#000000000",
    opacity: 0.3,
    strokeWidth: 0.78542
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17 14c-1.662 0-3 1.338-3 3v62c0 1.662 1.338 3 3 3h62c1.662 0 3-1.338 3-3v-62c0-1.662-1.338-3-3-3zm0 0.96875h62c1.1401 0 2.0312 0.89117 2.0312 2.0312v62c0 1.1401-0.89117 2.0312-2.0312 2.0312h-62c-1.1401 0-2.0312-0.89117-2.0312-2.0312v-62c0-1.1401 0.89117-2.0312 2.0312-2.0312z",
    color: "#000000000",
    opacity: 0.6,
    strokeWidth: 0.78542
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4aaee6",
    stroke: "#4aaee6",
    strokeWidth: 1.5708
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73 12v70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 12v70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 12v70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 12v70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 12v70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 71h70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 59h70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 47h70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 35h70",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 23h70",
    opacity: 0.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#4aaee6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 36,
    width: 9,
    height: 2,
    rx: 0.9,
    ry: 0.66667,
    strokeWidth: 0.80761
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 32,
    width: 9,
    height: 2,
    rx: 0.9,
    ry: 0.66667,
    strokeWidth: 0.80761
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 28,
    width: 9,
    height: 2,
    rx: 0.9,
    ry: 0.66667,
    opacity: 0.5,
    strokeWidth: 0.76384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 24,
    width: 9,
    height: 2,
    rx: 0.9,
    ry: 0.66667,
    opacity: 0.5,
    strokeWidth: 0.76384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 20,
    width: 9,
    height: 2,
    rx: 0.9,
    ry: 0.66667,
    opacity: 0.5,
    strokeWidth: 0.76384
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(4.2286 0 0 4.2286 53.026 49.762)",
    x: 15,
    y: 15,
    width: 66,
    height: 66,
    rx: 12,
    ry: 12,
    clipPath: "url(#b)",
    fill: "#4aaee6",
    filter: "url(#d)",
    opacity: 0.1,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.4038
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0589 0 0 1.0589 -11.305 -11.579)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.75)",
    d: "m256 116.3c-80.162 0-172.31 63.67-238.49 163.59a13.252 13.252 0 0 0 2.1504 17.137c75.893 68.725 167.31 121.03 236.34 121.03 68.879 0 163.09-51.092 236.6-121.27a13.252 13.252 0 0 0 1.793-17.061c-71.209-104.23-158.79-163.43-238.39-163.43z",
    color: "#000000",
    opacity: 0.3,
    strokeLinejoin: "round",
    strokeWidth: 25.028,
    style: {
      InkscapeStroke: "none"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m192 89.66c-54.63 0-122.26 45.281-170.58 118.24 55.745 50.48 124.2 88.199 170.58 88.199s116.88-36.922 170.58-88.199c-52.235-76.458-115.96-118.24-170.58-118.24z",
    fill: "#fff",
    stroke: "#3b8bb8",
    strokeLinejoin: "round",
    strokeWidth: 18.771
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m192 107.54c-52.745 0-118.04 38.722-164.7 101.12 53.822 43.168 119.91 75.423 164.7 75.423s112.84-31.574 164.7-75.423c-50.433-65.384-111.95-101.12-164.7-101.12z",
    fill: "url(#a)",
    stroke: "#4aaee6",
    strokeLinejoin: "round",
    strokeWidth: 18.771
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.39,
    cy: 197.77,
    r: 70.134,
    fill: "#4aaee6",
    fillOpacity: 0.49804,
    stroke: "#4aaee6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.34902,
    strokeWidth: 35.415
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m192 135.43v122.32",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3.5415
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m253.16 196.59h-122.32",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3.5415
  })), /*#__PURE__*/React.createElement("path", {
    d: "m192 97.6c-57.609 0-124.51 40.727-172.66 105.1a9.939 9.939 0 0 0 1.7402 13.705c55.034 44.141 121.36 77.607 170.92 77.607 49.456 0 117.78-32.673 171.12-77.771a9.939 9.939 0 0 0 1.4512-13.658c-51.75-67.092-115.33-104.98-172.57-104.98zm0 19.875c46.258 0 102.78 30.929 150.65 89.57-49.438 39.365-112.49 67.094-150.65 67.094-38.075 0-99.429-28.244-150.62-67.322 44.684-55.729 104.85-89.342 150.62-89.342z",
    color: "#000000",
    fill: "#4aaee6",
    strokeLinejoin: "round",
    strokeWidth: 0.94439,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 117.47c-45.771 0-105.94 33.613-150.62 89.342 0.50436 0.385 1.0245 0.75092 1.5308 1.1338 44.521-54.604 103.84-87.476 149.09-87.476 45.766 0 101.57 30.321 149.11 87.756 0.50866-0.40032 1.0366-0.78227 1.5425-1.185-47.867-58.642-104.39-89.571-150.65-89.571zm174.5 92.679a9.939 9.939 0 0 1-3.3823 6.0879c-53.334 45.099-121.66 77.771-171.12 77.771-49.557 0-115.88-33.466-170.92-77.607a9.939 9.939 0 0 1-3.4761-6.0015 9.939 9.939 0 0 0 3.4761 9.0015c55.034 44.141 121.36 77.607 170.92 77.607 49.456 0 117.78-32.673 171.12-77.771a9.939 9.939 0 0 0 3.3823-9.0879z",
    color: "#000000",
    opacity: 0.1,
    strokeLinejoin: "round",
    strokeWidth: 0.94439,
    style: {
      InkscapeStroke: "none",
      mixBlendMode: "normal"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmap);
export default __webpack_public_path__ + "static/media/nmap.3f36d0da5f70687520d02d67bc328e6b.svg";
export { ForwardRef as ReactComponent };